export default __webpack_public_path__ + "static/DSC_0291-40fabef62c43964e76d40a01983ad82c.jpg";